/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfCallSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type CallDirection, type PaginatedListOfCallSummary, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { AnswerersRequestBuilderRequestsMetadata, type AnswerersRequestBuilder } from './answerers/index.js';
// @ts-ignore
import { CallsItemRequestBuilderNavigationMetadata, type CallsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { LinesRequestBuilderRequestsMetadata, type LinesRequestBuilder } from './lines/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /calls
 */
export interface CallsRequestBuilder extends BaseRequestBuilder<CallsRequestBuilder> {
    /**
     * The answerers property
     */
    get answerers(): AnswerersRequestBuilder;
    /**
     * The lines property
     */
    get lines(): LinesRequestBuilder;
    /**
     * Gets an item from the ApiSdk.calls.item collection
     * @param id Unique identifier of the item
     * @returns {CallsItemRequestBuilder}
     */
     byId(id: Guid) : CallsItemRequestBuilder;
    /**
     * GetCalls
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfCallSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<CallsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfCallSummary | undefined>;
    /**
     * GetCalls
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CallsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetCalls
 */
export interface CallsRequestBuilderGetQueryParameters {
    answeredBy?: string[];
    calledNumber?: string[];
    criteria?: string;
    direction?: CallDirection;
    pageNumber?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const CallsRequestBuilderUriTemplate = "{+baseurl}/calls{?AnsweredBy*,CalledNumber*,Criteria*,Direction*,PageNumber*,PageSize*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const CallsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "answeredBy": "AnsweredBy",
    "calledNumber": "CalledNumber",
    "criteria": "Criteria",
    "direction": "Direction",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CallsRequestBuilderNavigationMetadata: Record<Exclude<keyof CallsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        navigationMetadata: CallsItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    answerers: {
        requestsMetadata: AnswerersRequestBuilderRequestsMetadata,
    },
    lines: {
        requestsMetadata: LinesRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CallsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CallsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfCallSummaryFromDiscriminatorValue,
        queryParametersMapper: CallsRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
